import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe, Instagram } from "lucide-react";
import myPropertyLogo from "@/assets/myproperty-logo.png";
const Footer = () => {
  return <footer className="bg-primary text-primary-foreground">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4" aria-label="Mypropertyku - Halaman Utama">
              <span className="sr-only">Mypropertyku</span>
            </Link>
            <p className="text-sm text-primary-foreground/70 mb-6">
              Marketplace properti aman dan terverifikasi di Indonesia. Cek legalitas, kurangi risiko sengketa.
            </p>
            <div className="flex flex-col gap-2 text-sm text-primary-foreground/70">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>info@mypropertyku.id</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>+6289636981105</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Bekasi, Indonesia</span>
              </div>
            </div>
            
            {/* Social Links */}
            <div className="flex items-center gap-3 mt-4">
              <a href="https://mypropertyku.lovable.app/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="Website">
                <Globe className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/myproperty_land/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Properti */}
          <div>
            <h3 className="font-semibold mb-4 text-primary-foreground">Properti</h3>
            <ul className="space-y-2.5 text-sm text-primary-foreground/70">
              <li><Link to="/listings" className="hover:text-primary-foreground transition-colors">Cari Properti</Link></li>
              <li><Link to="/listings?type=rumah" className="hover:text-primary-foreground transition-colors">Rumah</Link></li>
              <li><Link to="/listings?type=apartemen" className="hover:text-primary-foreground transition-colors">Apartemen</Link></li>
              <li><Link to="/listings?type=tanah" className="hover:text-primary-foreground transition-colors">Tanah</Link></li>
              <li><Link to="/listings?type=ruko" className="hover:text-primary-foreground transition-colors">Ruko</Link></li>
            </ul>
          </div>

          {/* Layanan */}
          <div>
            <h3 className="font-semibold mb-4 text-primary-foreground">Layanan</h3>
            <ul className="space-y-2.5 text-sm text-primary-foreground/70">
              <li><Link to="/post-property" className="hover:text-primary-foreground transition-colors">Pasang Iklan</Link></li>
              <li><Link to="/how-it-works" className="hover:text-primary-foreground transition-colors">Cara Kerja</Link></li>
              <li><Link to="/pricing" className="hover:text-primary-foreground transition-colors">Harga Layanan</Link></li>
              <li><Link to="/about" className="hover:text-primary-foreground transition-colors">Tentang Kami</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-primary-foreground">Legal</h3>
            <ul className="space-y-2.5 text-sm text-primary-foreground/70">
              <li><Link to="/privacy" className="hover:text-primary-foreground transition-colors">Kebijakan Privasi</Link></li>
              <li><Link to="/terms" className="hover:text-primary-foreground transition-colors">Syarat & Ketentuan</Link></li>
              <li><Link to="/disclaimer" className="hover:text-primary-foreground transition-colors">Disclaimer</Link></li>
              <li><Link to="/contact" className="hover:text-primary-foreground transition-colors">Hubungi Kami</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/60">
            <p>© 2025 Mypropertyku. Hak cipta dilindungi undang-undang.</p>
            <p className="text-xs">Disclaimer: Mypropertyku tidak menjamin kepemilikan atau legalitas properti. 
Selalu lakukan verifikasi mandiri dan kami akan memverikasi juga legalitas penjual.</p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;